import { render } from "./StudentTrainingCalendar.vue?vue&type=template&id=17fd863f"
import script from "./StudentTrainingCalendar.vue?vue&type=script&lang=js"
export * from "./StudentTrainingCalendar.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__